<template>
  <div class="content-box">
    <Title />
    <div class="nav-wrapper">
      <div class="vertical-nav">
        <div
          v-for="(primaryItem, primaryIndex) of navData"
          :key="'primary-' + primaryIndex"
          class="nav-row"
        >
          <div
            class="primary-item"
            :class="{ active: isPrimaryActive(primaryIndex) }"
            @click="handlePrimarySelect(primaryIndex)"
          >
            {{ primaryItem.label }}
          </div>
          <div class="secondary-items">
            <span
              v-for="(secondaryItem, secondaryIndex) of primaryItem.children"
              :key="'secondary-' + primaryIndex + '-' + secondaryIndex"
              class="secondary-item"
              :class="{ active: isSecondaryActive(primaryIndex, secondaryIndex) }"
              @click.stop="handleSecondarySelect(primaryIndex, secondaryIndex)"
            >
              {{ secondaryItem.label }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in allNavItems"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activePrimaryIndex: 0,
      activeSecondaryIndex: 0,
      name: "首页",
      navData: [
        {
          label: "资讯",
          children: [
            {
              value: "汽车",
              label: "汽车",
            },
            {
              value: "智驾",
              label: "智驾",
            },
            {
              value: "养车",
              label: "养车",
            },
            {
              value: "汽配",
              label: "汽配",
            },
            {
              value: "二手车",
              label: "二手车",
            },
          ],
        },
        {
          label: "互联网造车",
          children: [
            
            {
              value: "小米 车",
              label: "小米",
            },
            {
              value: "华为 车",
              label: "华为",
            },
            {
              value: "字节 车",
              label: "字节",
            },
            {
              value: "京东 车",
              label: "京东",
            },
            {
              value: "抖音 车",
              label: "抖音",
            },
          ],
        },
        {
          label: "造车新势力",
          children: [
            {
              value: "特斯拉",
              label: "特斯拉",
            },
            {
              value: "比亚迪",
              label: "比亚迪",
            },
            {
              value: "极氪",
              label: "极氪",
            },
            {
              value: "理想",
              label: "理想",
            },
            {
              value: "蔚来",
              label: "蔚来",
            },
            {
              value: "小鹏",
              label: "小鹏",
            },
            {
              value: "零跑",
              label: "零跑",
            },
            {
              value: "深蓝",
              label: "深蓝",
            },
            {
              value: "智己",
              label: "智己",
            },
            {
              value: "阿维塔",
              label: "阿维塔",
            },
            {
              value: "腾势",
              label: "腾势",
            },
            {
              value: "昊铂",
              label: "昊铂",
            },
            {
              value: "极狐",
              label: "极狐",
            },
          ],
        },
        {
          label: "传统车企",
          children: [
            {
              value: "吉利",
              label: "吉利",
            },
            {
              value: "广汽",
              label: "广汽",
            },
            {
              value: "上汽",
              label: "上汽",
            },
            {
              value: "长安",
              label: "长安",
            },
            {
              value: "一汽",
              label: "一汽",
            },
            {
              value: "长城",
              label: "长城",
            },
            {
              value: "宝马",
              label: "宝马",
            },
            {
              value: "奔驰",
              label: "奔驰",
            },
            {
              value: "奥迪",
              label: "奥迪",
            },
          ],
        },
        {
          label: "汽车电商",
          children: [
            {
              value: "瓜子二手车",
              label: "瓜子二手车",
            },
            {
              value: "优信",
              label: "优信",
            },
            {
              value: "人人车",
              label: "人人车",
            },
            {
              value: "天天拍车",
              label: "天天拍车",
            },
            {
              value: "淘车车",
              label: "淘车车",
            },
            {
              value: "卖好车",
              label: "卖好车",
            },
            {
              value: "大搜车",
              label: "大搜车",
            },
          ],
        },
        {
          label: "汽车后市场",
          children: [
            {
              value: "途虎",
              label: "途虎",
            },
            {
              value: "天猫养车",
              label: "天猫养车",
            },
            {
              value: "京东养车",
              label: "京东养车",
            },
            {
              value: "车享家",
              label: "车享家",
            },
            {
              value: "车点点",
              label: "车点点",
            },
            
          ],
        },
        {
          label: "租车",
          children: [
            {
              value: "租租车",
              label: "租租车",
            },
            {
              value: "神州租车",
              label: "神州租车",
            },
            {
              value: "一嗨租车",
              label: "一嗨租车",
            },
            {
              value: "悟空租车",
              label: "悟空租车",
            },
          ],
        },
      ],
      params: {
        json: 0,
        filter: ["研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  computed: {
    currentSecondaryNav() {
      return this.navData[this.activePrimaryIndex]?.children || [];
    },
    allNavItems() {
      return this.navData.flatMap((item) => item.children);
    },
    currentSelectedItem() {
      const children = this.navData[this.activePrimaryIndex]?.children || [];
      return children[this.activeSecondaryIndex];
    },
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.currentSelectedItem?.value || "车");
    this.$store.dispatch("getText");
  },
  methods: {
    isPrimaryActive(primaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === 0;
    },
    isSecondaryActive(primaryIndex, secondaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === secondaryIndex;
    },
    handlePrimarySelect(primaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = 0;
      const item = this.navData[primaryIndex]?.children[0];
      const searchKey = item?.keyword || item?.value || "车";
      this.name = item?.label || "滚动播报";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSecondarySelect(primaryIndex, secondaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = secondaryIndex;
      const item = this.navData[primaryIndex]?.children[secondaryIndex];
      const searchKey = item?.keyword || item?.value;
      this.name = item?.label || "";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.name = this.allNavItems.find((item) => item.value === value)?.label || value;
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.nav-wrapper {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border-bottom: 2px solid #e74c3c;
}
.vertical-nav {
  padding: 8px 0;
}
.nav-row {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
  transition: background-color 0.3s ease;
}
.nav-row:last-child {
  border-bottom: none;
}
.nav-row:hover {
  background-color: rgba(231, 76, 60, 0.05);
}
.primary-item {
  flex-shrink: 0;
  min-width: 80px;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-align: center;
}
.primary-item:hover {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.1);
}
.primary-item.active {
  color: #fff;
  background-color: #e74c3c;
}
.secondary-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 16px;
}
.secondary-item {
  padding: 4px 12px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
}
.secondary-item:hover {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.1);
}
.secondary-item.active {
  color: #fff;
  background-color: #e74c3c;
}
@media (max-width: 1100px) {
  .primary-item {
    min-width: 60px;
    padding: 4px 8px;
    font-size: 13px;
  }
  .secondary-item {
    padding: 3px 8px;
    font-size: 12px;
  }
}
@media (max-width: 768px) {
  .nav-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 12px;
  }
  .primary-item {
    min-width: 100%;
    text-align: left;
    margin-bottom: 8px;
  }
  .secondary-items {
    margin-left: 0;
    width: 100%;
  }
  .secondary-item {
    flex: 0 0 calc(44% - 4px);
    text-align: center;
  }
}
</style>